// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rqKa","title":"styles_title__3QNYZ"};